import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {BonusStatusInfo} from "@/store/shop/types";
import {Link} from "@/scenes.ui/link";
import BonusPointUtils from "@/utils/bonus-point-utils";
import ShopStore from "@/store/shop";
import PlayerStore from "@/store/player";
import CU from "@/utils/c-u";

export class PointsReminderPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, showManual: () => unknown, openShop: () => unknown) {
        super(scene, canvas, Tr('pnts.nom'));

        let mainText = TextUtils.addTextAdvanced(scene, '', 0, -170,
            '#20ffe5', 16, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let pointsText = TextUtils.addTextAdvanced(scene, '', 0, mainText.y / CU.S + 60,
            '#e7e7e7', 13, 'normal', 450, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let agitText = TextUtils.addTextAdvanced(scene, '', 0, pointsText.y / CU.S + 60,
            '#ffea0b', 16, 'normal', 450, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let statusText = TextUtils.addTextAdvanced(scene, '', 0, agitText.y / CU.S + 80,
            '#65ff2d', 12, 'normal', 450, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let descText = TextUtils.addTextAdvanced(scene, '', 0, statusText.y / CU.S + 20,
            '#b6b6b6', 13, 'normal', 450, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let manual = new Link(scene, 0, descText.y + 20 * CU.S, Tr('det'), showManual,
            '#b6b6b6', 12, 0.5);

        let self = this;
        ShopStore.fetchBonusStatusInfo().then((bi: BonusStatusInfo) => {
            if (self.active) {
                mainText.setText(TrSpace('rem') + bi.remainTime.toUpperCase() + SpaceTr('bf.obs'));
                pointsText.setText(TrSpace('u.hv.bns') + String(bi.points));
                agitText.setText(Tr('bt.agit'));
                statusText.setText(BonusPointUtils.getStatusNominative(bi.status) + SpaceTr('stts'));
                descText.setText(TrSpace('hv.bns') + String(bi.currentBonusPercent) + Tr('pct.fr'));
            }
        });

        this.add([mainText, pointsText, agitText, statusText, descText, manual]);

        this.addCustomButton(-100, 170, Tr('v.magazin'), Keys.UI_ART_GREEN_BUTTON, undefined, Keys.OFFER_SHOP_ICON, () => {
            openShop();
        });
        this.addCustomButton(100, 170, Tr('zakrit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});

        this.setOnCLoseCallback(() => {
            PlayerStore.resetNotification();
        });
    }
}
